import { getVariantItemImageUrl } from './get-product-image-url.js';

const consolidateParentFacets = (variants)=>{
    const parentFacetsMap = new Map();
    variants.forEach((variant)=>{
        const { facets , sku , slug , media , displayName , isPublished  } = variant;
        if (!isPublished) return;
        if (!facets.color && !facets.size && !!facets.other) {
            /* 
      for now 'other" facets are mutually exclusive from size & color. Meaning that 'other' facets don't support multivariancy.
      so the facet tree is either:
          color, with size as a child facet
          other, without any child facets
      */ const parentFacetItem = parentFacetsMap.get(facets.other) || {
                facetTerm: facets.other,
                type: 'other',
                sku,
                slug,
                name: displayName,
                imageUrl: getVariantItemImageUrl(media),
                childFacets: [],
                skuCollection: [],
                showFacetName: false
            };
            parentFacetItem.skuCollection.push(sku);
            parentFacetsMap.set(facets.other, parentFacetItem);
        } else if (facets.color) {
            const parentFacetItem = parentFacetsMap.get(facets.color) || {
                facetTerm: facets.color,
                type: 'color',
                slug,
                name: displayName,
                imageUrl: getVariantItemImageUrl(media),
                childFacets: [],
                sku,
                skuCollection: [],
                showFacetName: true
            };
            // Add facets.size if available
            if (!!facets.size) {
                const newChildFacet = {
                    facetTerm: facets.size,
                    type: 'size',
                    sku,
                    slug,
                    name: displayName,
                    showFacetName: false
                };
                parentFacetItem.childFacets.push(newChildFacet);
            }
            parentFacetItem.skuCollection.push(sku);
            parentFacetsMap.set(facets.color, parentFacetItem);
        }
    });
    const facetsMap = Object.fromEntries(parentFacetsMap);
    const parentFacets = Object.values(facetsMap);
    return parentFacets;
};

export { consolidateParentFacets };
//# sourceMappingURL=consolidate-parent-facets.js.map
